import React from 'react'

class Footer extends React.Component {
  render() {
    return (
      <section id="footer">
        <ul className="icons">
          <li>
            <a href="https://twitter.com/depsiapp" className="icon alt fa-twitter">
              <span className="label">Twitter</span>
            </a>
          </li>
          <li>
            <a href="mailto:depsicompany@gmail.com" className="icon alt fa-envelope">
              <span className="label">Email</span>
            </a>
          </li>
        </ul>
      </section>
    )
  }
}

export default Footer
